import '../App.css';
import React, {Component, Container} from 'react';
import {Row,Col,Image,Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
// import NavBarTop from "./navbar";
// import Footer from "./footer";

// email: hicusinvestment@outlook.com pw:Investhicus2022
//fixer.io exchange rate
//http://data.fixer.io/api/latest?access_key=c06cd1b831f00ec6c85cbac41eb810b1
// params: latest, historical, convert, time-series, fluctuation

//coinlayer.com cryptocurrency
//http://api.coinlayer.com/api/live?access_key=bca90b9e4854ff3c17f9d4fd088d661b
// params: list, live historical, convert, timeframe, change

//https://news.bitcoin.com/
class IndxePage extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    };

    this.setval = this.setval.bind(this)
  }

  setval(obj){
    this.setState(obj)
  }
  componentDidMount(){ 
  }      
      
  render(){
    return (
      <div style={{padding:"1% 1%"}}>
      <div className="home-content-div">
        {/* <div>
            <img  src="./assets/about.png" alt="" style={{height:"100%","width":"100%",paddingLeft:"1.7%",paddingRight:"1.7%"}}/>
        </div> */}

        <div style={{backgroundColor:"rgba(255,255,255,1)",fontSize:"2.3rem",margin:"30px 0px",color:"rgba(130,0,0,1)",fontFamily:"Courgette",borderRadius:"10px"
          }}>PLEASE SELECT YOUR COMPETITION</div>

        <div className="indexpage-cardwrapper">
          
          <div className={["indexpage-card"].join(" ")} onClick={(e)=>{this.props.setval({comp:"icmt"})}}>
            <a href="/icmt">
                <img src="assets/icmt-poster-2026.png" width="95%" />
                <div style={{fontSize:"1.5rem",margin:"25px 10px",fontFamily:"Courgette"}}>
                  {"International Classical Music Talent Competition"}
                </div>
            </a>
            </div>

          <div className={["indexpage-card"].join(" ")} onClick={(e)=>{this.props.setval({comp:"iypo"})}} >
          <a href="/iypo">
                <img src="assets/iypo-poster-2026.PNG" width="100%" />
                <div style={{fontSize:"1.5rem",margin:"25px 10px",fontFamily:"Courgette"}}>
                {"International Young Painter Open Competition"}
                </div>
          
                </a>
          </div>

           <div className={["indexpage-card"].join(" ")} onClick={(e)=>{this.props.setval({comp:"iswc"})}} >
          <a href="/iswc">
                <img src="assets/iswc-poster-2026.PNG" width="95%" />
                <div style={{fontSize:"1.5rem",margin:"25px 10px",fontFamily:"Courgette"}}>
                {"International English Speech Art and Writing Competition"}
                </div>
          
                </a>
          </div>

          
 
        </div>

      </div>

       
        
        
          
      </div>
    );
  }
  }
  

export default IndxePage;
